var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53168 8.03181L11.2417 8.03181C11.8115 8.03181 12.2734 7.5699 12.2734 7.00012C12.2734 6.43031 11.8115 5.96843 11.2417 5.96846L7.53167 5.96842L7.53166 2.25833C7.53166 1.68852 7.06978 1.22664 6.5 1.22667C5.93022 1.22671 5.46827 1.68859 5.46831 2.25837L5.46828 5.96841L1.75825 5.96841C1.18844 5.96841 0.726519 6.43032 0.726557 7.0001C0.726521 7.285 0.842002 7.54288 1.02872 7.7296C1.21543 7.91631 1.47331 8.03179 1.75818 8.03179L5.46828 8.0318L5.46829 11.7419C5.46829 12.0268 5.58377 12.2846 5.77049 12.4713C5.9572 12.6581 6.21508 12.7735 6.49995 12.7735C7.06977 12.7735 7.53169 12.3116 7.53165 11.7419L7.53168 8.03181Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 13,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53168 8.03181L11.2417 8.03181C11.8115 8.03181 12.2734 7.5699 12.2734 7.00012C12.2734 6.43031 11.8115 5.96843 11.2417 5.96846L7.53167 5.96842L7.53166 2.25833C7.53166 1.68852 7.06978 1.22664 6.5 1.22667C5.93022 1.22671 5.46827 1.68859 5.46831 2.25837L5.46828 5.96841L1.75825 5.96841C1.18844 5.96841 0.726519 6.43032 0.726557 7.0001C0.726521 7.285 0.842002 7.54288 1.02872 7.7296C1.21543 7.91631 1.47331 8.03179 1.75818 8.03179L5.46828 8.0318L5.46829 11.7419C5.46829 12.0268 5.58377 12.2846 5.77049 12.4713C5.9572 12.6581 6.21508 12.7735 6.49995 12.7735C7.06977 12.7735 7.53169 12.3116 7.53165 11.7419L7.53168 8.03181Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.3801,
    height: 12.3801,
    transform: "matrix(0.707108 0.707105 -0.707108 0.707105 6.7583 -1.52588)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.3801,
    height: 12.3801,
    transform: "matrix(0.707108 0.707105 -0.707108 0.707105 6.7583 -1.52588)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "e2ced8d893cc9d05441b7f0dc7e44aa7.svg";
export { ForwardRef as ReactComponent };